// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1HeGj","left":"styles_left__2xl5p","desktopActions":"styles_desktopActions__3Y0v4","title":"styles_title__2QsSv"};